/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo, useState } from 'react';

import '@patternfly/react-core/dist/styles/base.css';
import _ from 'lodash';
import {
  Form,
  Divider
} from '@patternfly/react-core';
import ModelsContainer from '../../Model/ModelsContainer';
import ModelType from '../../Model/ModelType';
import { useTranslation } from '../../../localization/useTranslation';
import Tl from '../../../localization/LocalizationKeys';
import SimpleTable, { RowSelection } from '../../Common/SimpleTable/SimpleTable';

const model = [
  {
    type: ModelType.TEXT,
    label: Tl.common.parent,
    path: 'name',
    placeholder: Tl.admin.assetInfo.parent.placeholder,
    disabled: true
  }
];


const LinkResource = ({ parentItem, onLinkResources, data, isLoading, isLinking, hasError, columns, defaultSortBy, disableLink }) => {
  const [selectedResources, setSelectedResources] = useState([]);
  const T = useTranslation();

  const _onLinkResources = useCallback(() => {
    onLinkResources(selectedResources);
  }, [onLinkResources, selectedResources]);

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      return !parentItem.children?.some((child) => {
        return child.id === item.id;
      });
    });
  }, [data, parentItem]);

  return (
    <>
      <Form id="form">
        <ModelsContainer
          models={model}
          data={parentItem}
          setData={() => {}}
        />
      </Form>
      <Divider />
      <SimpleTable
        isLoading={isLoading && _.isEmpty(data)}
        onRowClick={() => { }}
        data={filteredData}
        columns={columns}
        sortBy={defaultSortBy}
        hasError={hasError}
        errorText={T.common.error.failed.loading.list}
        rowSelection={RowSelection.SINGLE} // multi need support for lists edge link api
        compact
        selectedRows={selectedResources}
        onSelectedRows={setSelectedResources}
        globalActions={[{ label: T.common.link, isDisabled: disableLink, onClick: _onLinkResources, isLoading: isLinking }]}
      />
    </>
  );
};

export default LinkResource;
